<template> 
    <v-container fluid justify-center>
        <v-row class="d-flex flex-column pt-1 px-16 mt-2">
            <p class="blog-section">
                Blogs by Tag
            </p>
            <p class="blog-summary">
                {{ id }}
            </p>
        </v-row>
        <v-row 
            v-if="!isFetching" 
            class="pt-12 blog-container"
        >
            <v-col
                v-for="blog in blogs"
                :key="blog.title"
                :elevation="0"
                class="d-flex individual-blog"
            >
                <router-link 
                    :to="'/blogs/' + blog.link" 
                    class="blog-link"
                >
                    <div class="image-container">
                        <v-img
                            cover
                            :aspect-ratio="1"
                            :src=blog.image
                            height="100%"
                            class="blog-image" 
                        />
                    </div>
                    <div class="details-container">
                        <div class="blog-title">
                            {{ blog.title }}
                        </div>
                        <div class="blog-blurb-pub-details">
                            <h4 class="pt-2 font-weight-light">
                                {{ blog.blurb }}
                            </h4>
                        </div>
                        <div class="blog-details">
                            <div
                                v-if="isBlogNew(blog.publishDate)"
                                class="blog-new-entry"
                            >New</div>
                        </div>
                    </div>
                </router-link>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col class="text-center pa-8 blogs-loading">
                Loading blogs...
            </v-col>
        </v-row>
    </v-container>
</template>
    
<script>
import axios from 'axios';
import titleMixin from '@/mixins/titleMixin';

export default {
    name: 'blogTag',
    mixins: [titleMixin],
    data: () => ({
        blogs: [],
        isFetching: true,
        hostName: {
            portfolioServer: process.env.VUE_APP_PORTFOLIO_SERVER
        }
    }),
    methods: {
                isBlogNew(publishDate) {
            if (!publishDate) {
                return false;
            }
        
            const published = new Date(publishDate);
            const now = new Date();
            const oneMonthAgo = new Date().setMonth(now.getMonth() - 1);

            return published >= oneMonthAgo && published <= now;
        }
    },
    props: ['id'],
    mounted: async function() {       
        let $vm = this;
        let reqTag = { tag: $vm.id }
        await axios.get(`${this.hostName.portfolioServer}/api/blogsByTag`, { params: reqTag })
        .then(response => {
            $vm.blogs = response.data;
            $vm.isFetching = false;
        })
        .catch(function(error) {
            console.log(error) 
        })
    },
}
</script>
    
<style lang="scss" scoped>
.row p {
    font-family: Gasoek One !important;
    color: var(--v-tropicalIndigo-base) !important;
    margin: 0;

    &.blog-section {
        font-size: 40px;
        letter-spacing: 10%;
        font-weight: 400;

        @media (width > 1000px) {
            font-size: 64px;
        }
    }

    &.blog-summary {
        font-size: 20px;

        @media (width > 1000px) {
            font-size: 30px;
        }
    }
}

.blog-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 35px;
    padding-bottom: 45px;
    padding-right: 55px;
    padding-left: 55px;

    .individual-blog {
        border-radius: 15px;
        background-color: #A09BE7;
        width: 100%;
        height: auto;
        padding: 0;

        .blog-link {
            display: flex;
            flex-direction: column;
            width: 100%;
            text-decoration: none;

            .blog-title, .blog-time {
                font-family: Bebas Neue;
            }

            .blog-new-entry {
                display: none;
            }

            .blog-title {
                color: white;
                font-size: 40px;
                line-height: 37px;
            }

            .image-container {
                flex: 0 0 50%;
            }

            .blog-image {
                height: auto;
                min-height: 0;
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
            }

            .details-container {
                display: flex;
                flex: 1 1 auto;
                min-height: 0;
                flex-direction: column;
                justify-content: space-between;
                padding: 30px;
                
                h4 {
                    font-family: IBM Plex Sans;
                    font-size: 24px;
                    color: white;
                }

                .blog-details {
                    display: none;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 15px;

                    .blog-time {
                        color: #fff;
                        font-size: 24px;
                        display: flex;
                        align-items: center;

                        &__icon {
                            padding-right: 8px;
                        }
                    }

                    .blog-new-entry {
                        color: var(--v-cambridgeBlue-base) !important;
                    }
                }
            }
        }
    }

    .individual-blog:first-child {
        background-color: #3A2E39;
        grid-column: span 2;
  
        .blog-link {
            flex-direction: row;
            
            .blog-image {
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;

                .image-container, .details-container {
                    width: 50%;
                    flex: 0 0 50%;
                }
            }
        }
        
        .blog-new-entry {
            padding: 1px 10px;
            border-radius: 16px;
            font-size: 24px;
            border: 5px solid var(--v-cambridgeBlue-base) !important;;
        }

        .blog-details {
            display: none;
        }
    }

    .individual-blog:nth-child(2) {
        grid-column: span 1;
    }

    @media (width < 1000px) {
        display: flex;
        flex-direction: column;
        align-content: center;
        padding: 14px;

        .individual-blog {
            width: 90%;
            
            .blog-link {
                flex-direction: row;
            
                .blog-image {
                    border-top-left-radius: 15px;
                    border-bottom-left-radius: 15px;
                    border-bottom-right-radius: 0px;
                    border-top-right-radius: 0px;
                }

                .details-container {
                    padding: 8px;
                    
                    .blog-title {
                        font-size: 22px;
                        line-height: 22px;
                    }

                    .blog-blurb-pub-details h4 {
                        font-size: 14px;
                        
                        .blog-details {
                            
                            .blog-new-entry {
                                padding: 1px 10px;
                                border-radius: 16px;
                                font-size: 24px;
                                border: 5px solid var(--v-cambridgeBlue-base) !important;;
                            }
                        }
                    }
                }
            }
        }
    }
}

.blogs-loading {
    padding-top: 20px;
    padding-bottom: 20px;
}
</style>